import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const receiverApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/customer/receiver",
      params,
    }),
  findOne: (id: number): AxiosPromise<any> =>
    request({
      url: "/v1/admin/receiver/" + id,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/receiver",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/receiver/${id}`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/receiver/${id}`,
      method: "delete",
    }),
};
